<template>
    <div class="container mt-5">
        <!-- <div class="row align-items-center">
            <div class="col-md-12 text-center">
                <img src="@/assets/faq.svg" alt="Logo" class="img-fluid" style="width: 60%;">
            </div>
        </div>
        <br> -->
        <h1 class="text-center">Tanya Jawab</h1>
        <div id="collapseContainer" class="row border rounded p-4 custom-collapse" style="border: 1px solid #ced4da; background-color: #ffffff;">
            <div class="col-md-12">
                <h4>Pertanyaan Yang Sering Diajukan</h4>
            </div>

            <div class="col-md-6 collapse-col" v-for="(question, index) in faqs" :key="index">
                <div class="card">
                    <div class="card-header" @click="toggleCollapse(index)" :aria-expanded="activeCollapse === index" :aria-controls="'collapse' + index">
                        {{ question.title }}
                        <i class="fas fa-chevron-down collapse-icon"></i>
                    </div>
                    <div class="collapse" :class="{ show: activeCollapse === index }" :id="'collapse' + index">
                        <div class="card-body">
                            <span>{{ question.answer }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activeCollapse: null, 
            faqs: [               
                {
                    title: "Saya menerima surat konfirmasi, apakah saya sudah ditilang?",
                    answer: "Belum. Surat konfirmasi adalah langkah awal dari penindakan di mana pemilik kendaraan wajib konfirmasi tentang kepemilikan kendaraan dan pengemudi kendaraan pada saat terjadinya pelanggaran."
                },
                {
                    title: "Apa yang dimaksud dengan No Registrasi dan No TNKB?",
                    answer: "No Registrasi adalah kode unik yang Anda terima via surat konfirmasi pada lembar ketiga. No TNKB (Tanda Nomor Kendaraan Bermotor) adalah No yang tertera pada Plat Nomor kendaraan Anda pada sisi depan dan belakang."
                },
                {
                    title: "Berapa lama batas waktu saya untuk konfirmasi?",
                    answer: "Anda memiliki batas waktu sampai dengan 8 hari dari terjadinya pelanggaran untuk melakukan konfirmasi."
                },
                {
                    title: "Apakah saya harus membayar denda menggunakan BRIVA?",
                    answer: "Untuk menghindari pemblokiran, maka metode pembayaran menggunakan BRIVA adalah mekanisme paling efisien."
                },
                {
                    title: "Kapankah batas waktu terakhir untuk pembayaran?",
                    answer: "Batas waktu terakhir untuk pembayaran adalah 15 hari dari tanggal pelanggaran. Jika gagal melakukan ini, maka Anda akan terblokir."
                },
                {
                    title: "Apakah saya dapat memilih untuk menghadiri sidang?",
                    answer: "Ya. Anda dapat menghadiri sidang."
                },
                {
                    title: "Bagaimana cara saya mendapatkan informasi mengenai tanggal dan lokasi pengadilan terkait pelanggaran saya?",
                    answer: "Setelah anda melakukan konfirmasi, maka anda akan menerima email konfirmasi dan email terkait tanggal dan lokasi pengadilan. Selain itu Anda akan mendapatkan SMS yang berisi kode BRIVA untuk menyelesaikan denda pelanggaran. Dengan menyelesaikan pembayaran, maka Anda tidak perlu datang ke sidang."
                },
                {
                    title: "Apa yang terjadi jika saya tidak mengetahui pengendara saat terjadinya pelanggaran?",
                    answer: "Kendaraan yang dioperasikan di jalan raya, memiliki potensi mencelakakan pengguna jalan raya lainnya, bahkan sampai meninggal dunia. Sebagai pemilik kendaraan, Anda wajib bertanggung jawab kepada siapa Anda meminjamkan kendaraan tersebut."
                },
                {
                    title: "Jika kendaraan saya sudah dipindah pemilik, apakah saya harus melakukan konfirmasi juga?",
                    answer: "Dengan melakukan konfirmasi dan memberikan info pengendara baru, maka Anda sudah berpartisipasi dalam usaha mentertibkan kepemilikan kendaraan. Dalam skenario terburuk di mana kendaraan terkait digunakan untuk tindakan kriminal, maka Anda sudah membantu mempermudah penyelidikan."
                },
                {
                    title: "Apakah ada tempat untuk konsultasi mengenai surat konfirmasi yang saya terima?",
                    answer: "Ya. Anda dapat datang ke Posko Gakkum ETLE yang ada di masing-masing wilayah Polda. Klik di sini untuk melihat Daftar Posko Gakkum ETLE."
                }
            ]
        };
    },
    methods: {
        toggleCollapse(index) {
            // Toggle the collapse state of the selected question
            this.activeCollapse = this.activeCollapse === index ? null : index;
        }
    }
}
</script>

<style scoped>
.collapse-col {
    margin-bottom: 20px;
}
.collapse-icon {
    float: right;
}
</style>
